const Homepage = () => (
  <div>
    <p>homepage content...?</p>
  </div>
);

export default Homepage;